import React from "react";
import classes from './footer.module.css'
import { Fragment } from "react";

function Footer(){
    return(
        <Fragment>
        
        <div className={classes.footer}> 
        
        </div>
        </Fragment>

    )
}

export default Footer